import { Component } from '@stencil/core';

@Component({
  tag: 'roche-magnet',
  styleUrl: 'roche-magnet.scss',
  shadow: true,
})
export class RocheMagnet {}
